export const getMatchPercentage = (preferences, booth) => {
    const { branscher, tjanster } = preferences

    const companyBranscher = booth["vi-soker-studenter-inom"]
    const companyTjanster = booth["vi-erbjuder-studenter"]

    const branschMatch =
        companyBranscher.filter((bransch) => branscher?.includes(bransch))
            .length || 0

    const tjanstMatch =
        companyTjanster.filter((tjanst) => tjanster?.includes(tjanst)).length ||
        0

    const totalMatch = branschMatch + tjanstMatch

    const branchCount = branscher?.length || 0

    const tjanstCount = tjanster?.length || 0

    const preferencesLength = branchCount + tjanstCount

    const percentage = (totalMatch / preferencesLength) * 100

    return Math.round(percentage)
}
